<script setup lang="ts">
import { DialogClose, useForwardProps } from 'reka-ui'

import { Button, ButtonGroup, type ButtonGroupProps } from '@/components'

export interface DialogFooterActionsProps extends ButtonGroupProps {
  /** Label of the cancel action button. */

  cancelActionLabel?: string
}

const { cancelActionLabel, ...rest } = defineProps<DialogFooterActionsProps>()
const forward = useForwardProps(rest)
</script>

<template>
  <ButtonGroup v-bind="forward">
    <DialogClose v-if="cancelActionLabel" as-child>
      <Button treatment="outline" variant="secondary">
        {{ cancelActionLabel }}
      </Button></DialogClose
    >
    <slot />
  </ButtonGroup>
</template>
